import { render, staticRenderFns } from "./AddGuardianForm.vue?vue&type=template&id=d3ee13ee&"
import script from "./AddGuardianForm.vue?vue&type=script&lang=js&"
export * from "./AddGuardianForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports